import { IconProps } from './Icon';

export function EntityRoleOutlineIcon({
  width,
  color,
}: IconProps): JSX.Element {
  const DEFAULT_WIDTH = '18';

  return (
    <svg
      color={color}
      height={width || DEFAULT_WIDTH}
      viewBox="0 0 24 24"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m.9296875 22c0 .5522461.4472656 1 1 1s1-.4477539 1-1c0-3.5288086 2.0314941-6.6528931 5.1980591-8.130249 1.0958862.7121582 2.3995972 1.130249 3.8009643 1.130249 1.4066772 0 2.7153931-.4208984 3.8138428-1.1380615.9453125.446228 1.8213501 1.0466309 2.550415 1.7752686 1.7001954 1.7006835 2.6367188 3.9604492 2.6367188 6.3627929 0 .5522461.4472656 1 1 1s1-.4477539 1-1c0-2.9365234-1.1445313-5.6982422-3.2226563-7.7768555-.6953735-.6957397-1.50354-1.2922974-2.3706055-1.7841187.9942017-1.2089233 1.5922852-2.75531 1.5922852-4.4390258 0-3.8598633-3.140625-7-7-7s-7 3.1401367-7 7c0 1.6796265.5956421 3.222229 1.5854492 4.4298706-3.4328002 1.9327393-5.5844726 5.5439453-5.5844726 9.5701294zm10.9990234-19c2.7568359 0 5 2.2431641 5 5s-2.2431641 5-5 5-5-2.2431641-5-5 2.2431641-5 5-5z" />
    </svg>
  );
}
